<template>
  <DataList
    title="Компанії"
    resource="crm-companies"
    :columns="columns"
    :get-items-fn="getCompanies"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as companiesApi from "../../backend/companiesApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Назва", name: "title" },
      { title: "Сайт", name: "website" },
    ],
  }),
  methods: {
    async getCompanies(...args) {
      var data = await companiesApi.getCompanies(args[0], args[1], args[2], args[3]);
      return data;
    },
  },
};
</script>